import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavItem.module.scss';
import NavItemLine from './NavItemLine/NavItemLine';
import cn from 'classnames';
import { HREF_TARGETS } from '../../system/menuConfig';
const NavItem = ({ title, line, className, onClick, href, isExternal, target, disabled }) => {
    const targetAttr = useMemo(() => (target ? target : HREF_TARGETS.SELF), [target]);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ "data-testid": "navItem", onClick: onClick, className: cn(styles.element, 'd-flex align-items-center') }, { children: isExternal ? (_jsx("a", Object.assign({ className: cn(styles.wrapper, className), href: href, target: targetAttr }, { children: title }))) : (_jsx(NavLink, Object.assign({ className: ({ isActive }) => cn(styles.wrapper, className, {
                        [styles.active]: isActive,
                        [styles.isDisabled]: disabled
                    }), to: href }, { children: title }))) })), line && _jsx(NavItemLine, {})] }));
};
export default NavItem;
